var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contact-form grid grid__base" }, [
    _c("div", { staticClass: "grid--container" }, [
      _c("div", { staticClass: "grid--row" }, [
        _c(
          "div",
          { staticClass: "contact-form--col grid--col" },
          [
            _vm.title
              ? _c("h2", { staticClass: "contact-form--title" }, [
                  _vm._v(_vm._s(_vm.title))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.text
              ? _c("p", { staticClass: "contact-form--description" }, [
                  _vm._v(_vm._s(_vm.text))
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "form-data-provider",
              _vm._b(
                {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(props) {
                        return _c(
                          "generic-form",
                          _vm._b(
                            { staticClass: "contact-form" },
                            "generic-form",
                            props,
                            false
                          )
                        )
                      }
                    }
                  ])
                },
                "form-data-provider",
                _vm.formData,
                false
              )
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63fa5b78", { render: render, staticRenderFns: staticRenderFns })
  }
}